import { Tipo_propiedad } from './../../../models/tipo_propiedad.model';
import { Component } from "@angular/core";
import { FormBuilder} from '@angular/forms';


@Component({
    selector: "page-tipo_propiedad",
    templateUrl: "./tipo_propiedad.component.html"
    
})

export class Tipo_propiedadComponent {
    public rows = [];
    public actualRow;
    public tipo_propiedad: Tipo_propiedad;
    public form;
    //public tipos: string[] =['URBANO','RURAL'];
    public tipos = {"urbano": false, "rural": false}

    constructor(private fb: FormBuilder){
        
        if(!JSON.parse(localStorage.getItem("tipo_propiedad"))){
            localStorage.setItem("tipo_propiedad", JSON.stringify(this.rows));
        }else{
            this.rows = JSON.parse(localStorage.getItem("tipo_propiedad"));
            this.tipos = { 
                "urbano": this.rows[0]? this.rows[0].tpradio.urbano:false,
                "rural": this.rows[0]?this.rows[0].tpradio.rural:false}
        }
        
       /* this.form = new FormGroup({
            options: new FormControl('', Validators.required)
        })*/
       
    }
   

    add_tipo_propiedad(){
        //console.log(event)
       // var checkTipoPropiedad = event.value;
       console.log(this.tipos);
        localStorage.setItem("tipo_propiedad",JSON.stringify([]));
        this.actualRow = localStorage.getItem("tipo_propiedad");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            tpradio: this.tipos
                     
        })
        localStorage.setItem("tipo_propiedad", JSON.stringify(this.rows));
        
    }
  
    delete_tipo_propiedad(id){
        for(let x = 0; x < this.rows.length; x++){
            if(id == x){
                this.rows.splice(x, 1);
                localStorage.setItem("tipo_propiedad", JSON.stringify(this.rows));
            }
        }
    }  
}